import React, { useState } from "react";
import BioModal from "../components/BioModal";

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <section id="about" className="w-full min-w-full h-full flex-shrink-0 snap-start flex items-center justify-center bg-gray-100 p-4 sm:p-6 md:p-8 overflow-y-auto">
      <div className="text-center max-w-4xl w-full bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-8 my-4 sm:my-0">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">About</h1>
        <h2 className="text-xl sm:text-2xl md:text-3xl mb-6 sm:mb-8">We Serve St. Louis and Surrounding Missouri Counties</h2>
        <p className="text-lg sm:text-xl md:text-2xl mb-4 sm:mb-6">Patrick Driscoll REALTOR, Broker<br />Driscoll Co, LLC</p>
        <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8">My career spanning nearly two decades since 2004, I have been working on accumulated a wealth of knowledge and expertise in the real estate industry.</p>
        <button onClick={() => setIsModalOpen(true)} className="bg-red-600 text-white px-6 py-3 rounded-full font-bold hover:bg-red-700 transition mb-6 sm:mb-8 min-h-[44px] touch-manipulation">My Full Bio</button>
        <ul className="text-base sm:text-lg md:text-xl list-disc list-inside text-left mb-8 space-y-1">
          <li>Expertise in residential real estate</li>
          <li>Specialization in commercial properties</li>
          <li>Proficient in investment property services</li>
          <li>Experienced in landlord/tenant representation</li>
        </ul>
      </div>
      <BioModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default About;